import React from 'react'
import { Burger } from '@dostavkee/web-ui'
import clsx from 'clsx'

import { useSidebarIsOpen } from '@/shared/model'

import styles from './header-mobile.module.scss'
import { HeaderMobileTitle } from './header-mobile-title'

interface HeaderMobileComposition {
    Title: typeof HeaderMobileTitle
}

interface HeaderMobileProps {
    title: string | React.ReactNode
    prefixElement?: React.ReactNode
    postfixElement?: React.ReactNode
    footer?: React.ReactNode
    variant?: 'default' | 'gradient'
}

export const HeaderMobile: React.FC<HeaderMobileProps> & HeaderMobileComposition = ({
    title,
    prefixElement,
    postfixElement,
    footer,
    variant = 'default',
}: HeaderMobileProps) => {
    const { setIsOpen } = useSidebarIsOpen()

    return (
        <header
            className={clsx(styles['header-mobile'], styles[`header-mobile--variant--${variant}`])}
        >
            <div style={{ width: 32, gridArea: 'prefix' }}>
                {prefixElement ?? <Burger onClick={() => setIsOpen(true)} />}
            </div>
            {typeof title === 'string' ? (
                <HeaderMobile.Title title={title} />
            ) : (
                <div className={styles['header-mobile__title-container']}>{title}</div>
            )}
            <div style={{ width: 32, gridArea: 'postfix' }}>{postfixElement}</div>
            {footer && <div className={styles['header-mobile__footer']}>{footer}</div>}
        </header>
    )
}

HeaderMobile.Title = HeaderMobileTitle

export default HeaderMobile
